import { Logo } from 'icons';
import { Helmet } from 'react-helmet';

export const Footer = () => {
  return (
    <>
      <Helmet>
        <title>Sonnen Raffstoren GmbH</title>
        <meta
          name="description"
          content="Sonnen Raffstoren GmbH provides premium external blinds, Markisen, Insektenschutz and shading solutions with a focus on durability, energy efficiency and aesthetic integration. Contact details, company address and service information are provided for customer support and inquiries. We stand behind our products with professional installation, warranty and maintenance services to ensure long-term performance and satisfaction."
        />
      </Helmet>
      <footer className="w-full bg-black text-white py-8 px-6 flex flex-col items-center md:flex-row md:justify-between">
        {/* Left Section - Details */}
        <div className="text-center md:text-left md:w-1/3">
          <p className="text-sm">
            &copy; {new Date().getFullYear()} Sonnen Raffstoren GmbH.
          </p>
          <p className="text-sm">All rights reserved.</p>
        </div>

        {/* Middle Section - Logo */}
        <div className="my-4 md:my-0">
          <Logo />
        </div>

        {/* Right Section - Additional Details */}
        <div className="text-center md:text-right md:w-1/3">
          <p className="text-sm">sonnenraffstoren@gmail.com</p>
          <p className="text-sm">Waldmannstrasse 33, 8590 Romanshorn</p>
        </div>
      </footer>
    </>
  );
};
